module.exports = __webpack_public_path__ + "img/solution16.845b0ff6.png";